// extracted by mini-css-extract-plugin
export default {"select_wrapper":"BalanceTest_select_wrapper__gdHwy","select_root":"BalanceTest_select_root__8mHi+"};